import React, {FC, ReactElement} from "react";
import {Title} from "../Title";
import {Card, Col, Nav, Row} from "react-bootstrap";
import {TelNavLink} from "../TelNavLink";
import unknown from "../Vorstand/vorstand/neu-temp/unknown.jpg";
import {SponsorsSlide} from "../Sponsors";

interface ImageCardProps {
    image: string;
    title: string;
    name: string;
    division: string;
    instructor: string;
    mail: string;
    tel: number;
    instagram: string;
    facebook: string;
    statistics: string;
}

const ImageCard: FC<ImageCardProps> = ({
                                           image,
                                           title,
                                           name,
                                           division,
                                           instructor,
                                           mail,
                                           tel,
                                           instagram,
                                           facebook,
                                           statistics
                                       }): ReactElement => {
    return (
        <Card className="text-center shadow-lg rounded-0 coloration shadow">
            <Card.Body>
                <Card.Title>{title}</Card.Title>
                <Card.Text>
                    <div>{name}</div>
                    <div><i className="p-1 bi-crosshair"/> {division}</div>
                    <div><i className="p-1 bi-person-fill"/> {instructor}</div>
                </Card.Text>
            </Card.Body>
            <Card.Footer>
                <Nav>
                    <Nav.Link active href={statistics} className="mx-auto">
                        <i className="bi-table coloration" style={{fontSize: '20px'}}/>
                    </Nav.Link>
                    <Nav.Link active href={"mailto:" + mail} className="mx-auto">
                        <i className="bi-at coloration" style={{fontSize: '20px'}}/>
                    </Nav.Link>
                    <TelNavLink tel={tel} fontSize={'18px'}/>
                    <Nav.Link active href={instagram} className="mx-auto">
                        <i className="bi-instagram coloration" style={{fontSize: '20px'}}/>
                    </Nav.Link>
                    <Nav.Link active href={facebook} className="mx-auto">
                        <i className="bi-facebook coloration" style={{fontSize: '20px'}}/>
                    </Nav.Link>
                </Nav>
            </Card.Footer>
        </Card>
    )
}

export const Mannschaften: FC = (): ReactElement => {
    return (
        <>
            <Title title={'Teams - Fußball'}/>
            <Row className="justify-content-md-center">
                <Col xl={3} lg={4} md={6} sm={6} className="p-4">
                    <ImageCard image={unknown} title={'Frauen'} name={'FC Groß Döhren'} division={'1.Nordharzklasse'}
                               instructor={'Lukas Zornhagen'} mail={"vorstand+damen@fc29.de"} tel={15164037643}
                               instagram={'https://www.instagram.com/fc_gr._doehren_damen/'}
                               facebook={'https://www.facebook.com/SgKlMahnerDamen/'}
                               statistics={'https://www.fussball.de/mannschaft/fc-gross-doehren-fc-gross-doehren-niedersachsen/-/saison/2324/team-id/020SNOALA8000000VS548984VSKC9ER0#!/'}/>
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="p-4">
                    <ImageCard image={unknown} title={'I. Herren'} name={'FC Groß Döhren'} division={'Bezirksliga'}
                               instructor={'Jan Rinkel'} mail={"vorstand+ersteHerren@fc29.de"} tel={15203470851}
                               instagram={'https://www.instagram.com/fc29.de/'}
                               facebook={'https://www.facebook.com/fc29.de/'}
                               statistics={'https://www.fussball.de/mannschaft/fc-gross-doehren-fc-gross-doehren-niedersachsen/-/saison/2324/team-id/011MID1R9O000000VTVG0001VTR8C1K7#!/'}/>
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="p-4">
                    <ImageCard image={unknown} title={'II. Herren'} name={'SG Lochtum / Döhren'} division={'1.Nordharzklasse'}
                               instructor={'Nick Thielecke'} mail={"vorstand+zweiteHerren@fc29.de"} tel={1799382975}
                               instagram={'https://www.instagram.com/tsvlochtum1888/'}
                               facebook={'https://www.facebook.com/groups/3192915354356399/'}
                               statistics={'https://www.fussball.de/mannschaft/sg-lochtum-gr-doehren-tsv-lochtum-niedersachsen/-/saison/2627/team-id/011MIEDQLO000000VTVG0001VTR8C1K7#!/'}/>
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="p-4">
                    <ImageCard image={unknown} title={'III. Herren'} name={'SG Lochtum / Döhren II'} division={'4.Nordharzklasse'}
                               instructor={'Lukas Zornhagen'} mail={"vorstand+zweiteHerren@fc29.de"} tel={15164037643}
                               instagram={'https://www.instagram.com/fc_gross_doehren_ultras/'}
                               facebook={'https://www.facebook.com/fc29.de/'}
                               statistics={'https://www.fussball.de/mannschaft/sg-lochtum-gross-doehren-ii-fc-gross-doehren-niedersachsen/-/saison/2627/team-id/019TFOH864000000VV0AG80NVVK3URHB#!/'}/>
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="p-4">
                    <ImageCard image={unknown} title={'Ü50 Senioren'} name={'SG Grube Fortuna'} division={'Nordharzklasse'}
                               instructor={'Michael Liebke'} mail={"vorstand+senioren@fc29.de"} tel={16097023252}
                               instagram={'https://www.instagram.com/fc_gross_doehren_ultras/'}
                               facebook={'https://www.facebook.com/fc29.de/'}
                               statistics={'https://www.fussball.de/mannschaft/sg-grube-fortuna-fc-gross-doehren-niedersachsen/-/saison/2324/team-id/02IC9IKE7S000000VS5489B2VU2I8R4H#!/'}/>
                </Col>
            </Row>
            <Title title={'Teams - Darts - Red White 29'}/>
            <Row className="justify-content-md-center">
                <Col xl={3} lg={4} md={6} sm={6} className="p-4">
                    <ImageCard image={unknown} title={'A-Mannschaft'} name={'Red White 29 Groß Döhren A'} division={'Bezirksklasse 02'}
                               instructor={'Kevin Michalsky'} mail={"vorstand+darten@fc29.de"} tel={1709372610}
                               instagram={'https://www.instagram.com/red_white_29_doehren/'}
                               facebook={'https://www.facebook.com/groups/2087567308094112'}
                               statistics={'https://2k-dart-software.com/frontend/events/10/event/1314/participants'}/>
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="p-4">
                    <ImageCard image={unknown} title={'B-Mannschaft'} name={'Red White 29 Groß Döhren B'} division={'2.Kreisklasse 05'}
                               instructor={'Ludwig Aures'} mail={"vorstand+darten@fc29.de"}
                               tel={16096783952} instagram={'https://www.instagram.com/red_white_29_doehren/'}
                               facebook={'https://www.facebook.com/groups/2087567308094112'}
                               statistics={'https://2k-dart-software.com/frontend/events/10/event/1345/participants'}/>
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="p-4">
                    <ImageCard image={unknown} title={'C-Mannschaft'} name={'Red White 29 Groß Döhren C'} division={'2.Kreisklasse 04'}
                               instructor={'Thorsten Bergmeier'} mail={"vorstand+darten@fc29.de"}
                               tel={16096783952} instagram={'https://www.instagram.com/red_white_29_doehren/'}
                               facebook={'https://www.facebook.com/groups/2087567308094112'}
                               statistics={'https://2k-dart-software.com/frontend/events/10/event/1340/participants'}/>
                </Col>
            </Row>
        </>
    )
}